export default "__VITE_ASSET__BBm_6w6f__"